import { makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import DashboardContext from '../context';
import _ from 'lodash';
import moment from 'moment';
import Text from 'modules/Text';
import theme from 'resources/theme';
import ImageLinks from 'resources/ImageLinks';
import OrderCard from './OrderCard';
import clsx from 'clsx';
import constant from 'resources/constant';
import { convertUTCToTimezone } from 'resources/internationalizationConfig';

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'absolute',
		right: 20,
		top: 20,
		zIndex: 1000,
		width: 330,
		borderRadius: 6,
		backgroundColor: theme.colors.white,
		maxHeight: 700,
		overflowY: 'auto',
	},
	route_item_wrap: {
		padding: 8,
		borderRadius: 4,
		backgroundColor: theme.colors.white,
		marginBottom: 8,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		boxShadow: `0px 2px 4px 0px rgba(196, 196, 196, 0.30)`,
	},
	number_wrap: {
		width: 16,
		height: 16,
		borderRadius: 8,
		backgroundColor: theme.colors.light_purple,
		marginRight: 4,
	},
	task_header: {
		// display: 'flex',
		// padding: '8px 14px',
		// alignItems: 'center',
		borderRadius: '8px',
		background: theme.colors.light_purple,
		// gap: 35,
	},
	task_sub_text: {
		fontSize: 10,
		color: theme.colors.lightGrey6,
	},
	on_progress_text: {
		fontSize: 14,
		marginBottom: 8,
		display: 'flex',
		width: 87,
		padding: '4px 12px 4px 0',
		justifyContent: 'center',
		alignItems: 'center',
		gap: 10,
		borderRadius: '0 0 14px 0',
		fontSize: 10,
	},
	rider_break_wrap: {
		marginTop: 13,
		height: 25,
		borderRadius: 4,
		backgroundColor: theme.colors.lightBlue2,
		border: `1px solid ${theme.colors.darkBlue}`,
		justifyContent: 'center',
		alignItems: 'center',
		gap: 7,
	},
}));

const today_date = moment().format('YYYY-MM-DD');

const ActiveTaskList = () => {
	const { set_center_position, set_zoom, set_selected_route_order_item, rider_active_task, selected_widget, app, selected_route_order_item, entity_details } =
		useContext(DashboardContext);
	const classes = useStyles();

	const handle_route_item_click = (item) => {
		if (item?.is_shared) return;
		set_center_position([item.task_location.latitude, item.task_location.longitude]);
		set_zoom(15);
		set_selected_route_order_item(item);
	};

	if (_.isEmpty(rider_active_task.routes) || !_.includes(selected_widget, 'route') || app.entity_type != 'rider') return null;
	if (!_.isEmpty(selected_route_order_item))
		return (
			<OrderCard
				data={selected_route_order_item}
				handle_close={() => {
					set_zoom(10);
					set_selected_route_order_item(null);
				}}
			/>
		);
	const drop_tasks = rider_active_task?.routes?.filter((item) => item.task_type === constant.TASK_TYPES.DROP.id && !_.isEmpty(item.expected_time));
	const task_count = rider_active_task?.routes?.filter((item) => !_.isEmpty(item.expected_time));
	const break_status = ['ACTIVE', 'REQUESTED'].includes(entity_details?.break_status);
	const is_requested_break = _.get(entity_details, 'break_status') == "REQUESTED" || false;

	return (
		<div className={classes.container}>
			<div style={{ padding: 16 }}>
				<div className={classes.task_header}>
					{(entity_details?.is_borrowed || entity_details?.is_shared) && (
					<Text
						semi
						className={classes.on_progress_text}
						style={
							entity_details?.is_borrowed
								? { background: theme.colors.lightGreen1, color: theme.colors.green }
								: { background: theme.colors.lightYellow, color: theme.colors.orange }
						}>
						On Project
					</Text>
					)}
					<div style={{display:'flex',alignItems:'center',padding:'8px 14px',gap:21
					}}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Text semi style={{ fontSize: 14, color: theme.colors.darkGrey7 }}>
								{task_count?.length}
							</Text>
							<Text medium style={{ fontSize: 12, color: theme.colors.darkGrey8 }}>
								Tasks
							</Text>
						</div>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Text semi style={{ fontSize: 14, color: theme.colors.darkGrey7 }}>
								{!_.isEmpty(drop_tasks)
									? convertUTCToTimezone(drop_tasks[drop_tasks.length - 1].expected_time, 'D MMM `YY hh:mm a')
									: '-'}
							</Text>
							<Text medium style={{ fontSize: 12, color: theme.colors.darkGrey8 }}>
								Completion Time
							</Text>
						</div>
					</div>
				</div>
				{(entity_details?.is_on_break || break_status) && (
					<div
						className={clsx(classes.rider_break_wrap, 'flex_center_content')}
						style={{
							border: is_requested_break ? `1px solid ${theme.colors.darkYellow}` : `1px solid ${theme.colors.darkBlue}`,
							background: is_requested_break ? theme.colors.lightYellow : theme.colors.lightBlue2,
						}}>
						<img src={is_requested_break ? ImageLinks.rider_break : ImageLinks.rider_break} height={14} width={14} alt='' />
						<Text medium style={{ fontSize: 12 }}>
							{is_requested_break ? 'Break requested by rider' : 'Rider is currently on break'}
						</Text>
					</div>
				)}
				<div className='flex_between_center' style={{ marginTop: 16 }}>
					<Text semi style={{ fontSize: 14 }}>
						Task Sequence
					</Text>
				</div>
				{_.map(rider_active_task.routes, (item, index) => {
					return (
						<div key={`route_detail_item_${index}`} className='d-flex align_item_center'>
							<div className={clsx(classes.number_wrap, 'flex_center_content')}>
								{_.isEmpty(item.expected_time) ? (
									<img src={ImageLinks.tick_circle_solid_gray} width={16} height={16} style={{ marginRight: 4 }} />
								) : (
									<Text bold style={{ fontSize: 12, color: theme.colors.primary }}>
										{index + 1}
									</Text>
								)}
							</div>
							<div
								className={classes.route_item_wrap}
								style={{ width: 300, cursor: item?.is_shared ? 'default' : 'pointer' }}
								onClick={() => handle_route_item_click(item)}>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<Text
										semi
										style={{
											fontSize: 12,
											color: item?.is_shared ? theme.colors.black : theme.colors.primary,
											textDecorationLine: item?.is_shared ? 'unset' : 'underline',
										}}>
										{item?.is_shared ? item?.business_name || '-' : item.trip_type === 4 ? item.trip_id : item.mcp_id}
									</Text>
								</div>

								<div>
									<div style={{ display: 'flex' }}>
										<Text semi style={{ fontSize: 12 }}>
											{!_.isNull(item.expected_time) && !_.isEmpty(item.expected_time)
												? convertUTCToTimezone(item.expected_time, 'hh:mm A').split(' ')[0]
												: '-'}
										</Text>
										<Text semi style={{ fontSize: 10, alignSelf: 'center' }}>
											{!_.isNull(item.expected_time) && !_.isEmpty(item.expected_time)
												? convertUTCToTimezone(item.expected_time, 'hh:mm A').split(' ')[1]
												: '-'}
										</Text>
									</div>
									<Text medium className={classes.task_sub_text}>
										Time
									</Text>
								</div>
								<div style={{ width: 58, height: 26 }}>
									<Text semi style={{ fontSize: 12, color: theme.colors.lightGrey2 }}>
										{constant.TRIP_STATUS_TEXT[item.status_id]}
									</Text>
								</div>
								<div className={classes.iconsUpDown}>
									{item.task_type === constant.TASK_TYPES.DROP.id ? (
										<img src={ImageLinks.chevron_down_solid_purple} width='16' height='16' alt='' />
									) : (
										<img src={ImageLinks.chevron_up_solid_green} width='16' height='16' alt='' />
									)}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ActiveTaskList;
